module.exports = __webpack_public_path__ + "static/icons/informa.fce6bf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/informa.svg
// module id = hNUD
// module chunks = 1